export default __webpack_public_path__ + "static/HelveticaNeueLTStd-MdCn-16bcf00d84882df075666fdf1971d4c9.woff";